module.exports = __webpack_public_path__ + "img/about-image-1.ef57c302.png";